module.exports = __webpack_public_path__ + "img/itunes.73778b59.svg";